export default __webpack_public_path__ + "static/media/vi_Samples.925655b4.mp4";